export class Tooltip {

  private static instance: Tooltip;

  private constructor() {
  }

  static getInstance(): Tooltip {
    if (!Tooltip.instance) {
      Tooltip.instance = new Tooltip();
    }
    return Tooltip.instance;
  }

  public readonly add = $localize`:@@tooltip.add:Add`;
  public readonly edit = $localize`:@@tooltip.edit:Edit`;
  public readonly delete = $localize`:@@tooltip.delete:Delete`;

  public readonly tableSettings = $localize`:@@tooltip.tableSettings:Table settings`;

  public readonly personal = $localize`:@@tooltip.personal:Personal settings`;

}
